import { useEffect, useState } from 'react'
import { useResetRecoilState, useSetRecoilState } from 'recoil'
import { CertCheckState, TimeoutState } from 'src/recoil/ui'
import styled from 'styled-components'

const TimerWrap = styled.span`
  position: absolute;
  right: 15px;
  color: #f63240;
  line-height: 60px;
`

const Timer = (props: { time: number }): JSX.Element => {
  const { time } = props
  const [minutes, setMinutes] = useState<number>(time / 60)
  const [seconds, setSeconds] = useState<number>(time % 60)

  const ResetTimeOut = useResetRecoilState(TimeoutState)
  const setCertCheck = useSetRecoilState(CertCheckState)

  useEffect(() => {
    const countdown = setInterval(() => {
      if (Number(seconds) > 0) {
        setSeconds(Number(seconds) - 1)
      } else {
        if (Number(minutes) === 0) {
          clearInterval(countdown)
        } else {
          setMinutes(Number(minutes) - 1)
          setSeconds(59)
        }
      }
    }, 1000)
    return () => {
      clearInterval(countdown as NodeJS.Timer)
    }
  }, [minutes, seconds])

  useEffect(() => {
    if (minutes === 0 && seconds === 0) {
      setTimeout(() => {
        setCertCheck(false)
        setMinutes(0)
        setSeconds(0)
        ResetTimeOut()
        alert('유효시간이 초과되었습니다. 인증번호를 다시 받으시기 바랍니다.')
      }, 1000)
    }
    // eslint-disable-next-line
  }, [minutes, seconds])
  return (
    <TimerWrap>
      0{minutes}:{seconds < 10 ? `0${seconds}` : seconds}
    </TimerWrap>
  )
}

export default Timer
